import { render, staticRenderFns } from "./bien-rediger-les-mentions-legales-pour-son-site-internet.vue?vue&type=template&id=1f11fe1c&"
import script from "./bien-rediger-les-mentions-legales-pour-son-site-internet.vue?vue&type=script&lang=js&"
export * from "./bien-rediger-les-mentions-legales-pour-son-site-internet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports